import { isApiError } from "@bw/shared/api";
import type { CheckinPassRefusal } from "@bw/shared/types/generated";

/**
 * Owner rule (#2691): once something has been used or has ended, no new
 * check-in QR can be made for it. The server refuses with a 409 `code`; these
 * are the plain words the player sees instead of a code or "Show code".
 */
export const CHECKIN_PASS_REFUSAL: Record<CheckinPassRefusal, { label: string; message: string }> = {
  already_checked_in: {
    label: "Checked in",
    message: "You're already checked in, so there's no new code to show.",
  },
  session_ended: {
    label: "Session ended",
    message: "This session has ended, so there's no code for it.",
  },
  booking_cancelled: {
    label: "Cancelled",
    message: "This booking was cancelled, so there's no code for it.",
  },
  booking_not_eligible: {
    label: "Not available",
    message: "This booking can't be checked in.",
  },
  checked_in_today: {
    label: "Checked in for today",
    message:
      "You're already checked in here today. Redeem one again on a later visit. Nothing was used.",
  },
  redemption_used: {
    label: "Code used",
    message: "This code already checked you in. Nothing more was used.",
  },
};

const CODES = new Set(Object.keys(CHECKIN_PASS_REFUSAL));

/** The refusal code a pass endpoint returned (409 detail.code), or null. */
export function checkinPassRefusal(error: unknown): CheckinPassRefusal | null {
  if (isApiError(error) && error.status === 409 && CODES.has(error.code)) {
    return error.code as CheckinPassRefusal;
  }
  return null;
}
